import { alpha, Chip, styled, Theme } from "@mui/material";
import { ChipColor, IStyledChipProps } from "./types";

const pickColor = (theme?: Theme): Record<ChipColor, any> => ({
    primary: (theme as any)?.palette?.primary?.darker,
    secondary: (theme as any)?.palette?.secondary?.light,
    tertiary: (theme as any)?.palette?.tertiary?.main,
    quaternary: (theme as any)?.palette?.tertiary?.light,
    neutral: (theme as any)?.palette?.neutral?.main,
    info: (theme as any)?.palette?.accentInfo?.main,
    success: (theme as any)?.palette?.accentSuccess?.main,
    warning: (theme as any)?.palette?.accentWarning?.main,
    error: (theme as any)?.palette?.accentError?.main,
});

const StyledChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== "customColor" && prop !== "customVariant",
})<IStyledChipProps>(({ theme, customColor = "neutral", customVariant = "filled" }) => {
    const color = pickColor(theme)[customColor] ?? (theme as any)?.palette?.neutral?.main;
    const filledTextColor = ["neutral", "error"].includes(customColor) ? (theme as any)?.palette?.neutral?.darkest : (theme as any)?.palette?.neutral?.lighter;

    if (customVariant === "outlined") {
        return {
            backgroundColor: "transparent",
            border: `1px solid ${color}`,
            cursor: "pointer",
            color,
            "& .MuiChip-label": {
                color: color,
            },
            "& .MuiTypography-root": {
                color: `${color} !important`,
                fontWeight: "600 !important",
            },
            "& .MuiChip-deleteIcon": {
                color,
                "&:hover": {
                    color,
                    opacity: 1,
                },
            },
            "&:hover": {
                backgroundColor: alpha(color, 0.08),
                "& .MuiChip-deleteIcon": {
                    color,
                },
            },
        };
    }

    return {
        backgroundColor: color,
        color: filledTextColor,
        "& .MuiChip-label": {
            color: filledTextColor,
        },
        "& .MuiTypography-root": {
            color: `${filledTextColor} !important`,
            fontWeight: "600 !important",
        },
        "& .MuiChip-deleteIcon": {
            color: filledTextColor,
            "&:hover": {
                color: filledTextColor,
                opacity: 1,
            },
        },
        "&:hover": {
            backgroundColor: alpha(color, 0.85),
            "& .MuiChip-deleteIcon": {
                color: filledTextColor,
            },
        },
    };
});

export { StyledChip };